import $ from 'jquery';
import { initHeroParticles } from '@js/parts/hero-particles';
import { initSiteHeader } from '@js/parts/header';
import { initPortfolioSlider } from '@js/parts/portfolio-slider';
import { initThemeToggle } from '@js/parts/theme';

$(function(){
  initThemeToggle();
  initHeroParticles();
  initSiteHeader();
  initPortfolioSlider();
});
